import React from 'react';
import { useSelector } from 'react-redux';

import MatchList from './MatchList';

import styles from './eventItem.scss';

const EventItem = (props) => {
    const {
        playerId,
        gameType,
        eligibleResults,
        subscriptionType,
        showVerified,
        limitResultDisplay,
        event,
        showDecimalForOwn,
        isProProfile,
        redirectUrl,
        scoreStatusMap,
        onScoreUpdateRequest,
    } = props;

    const auth = useSelector(({ auth }) => auth);
    const {
        results,
        draws,
    } = event;

    return (
        <div>
            {Array.isArray(draws) && draws.length > 0 && (
                <div>
                    {draws && draws.map((draw, i) => {
                        if (draw.results && draw.results.length > 0) {
                            return (
                                <div
                                    key={`draw-items-${draw.id}-${i}`}
                                    className={`${styles.eventItem}`}
                                >
                                    <MatchList
                                        results={draw.results}
                                        event={event}
                                        draw={draw}
                                        gameType={gameType}
                                        eligibleResults={eligibleResults}
                                        subscriptionType={subscriptionType}
                                        showVerified={showVerified}
                                        playerId={playerId}
                                        limitResultDisplay={limitResultDisplay}
                                        showDecimalForOwn={showDecimalForOwn}
                                        isProProfile={isProProfile}
                                        auth={auth}
                                        redirectUrl={redirectUrl}
                                        scoreStatusMap={scoreStatusMap}
                                        onScoreUpdateRequest={onScoreUpdateRequest}
                                        skipBatchCall={true}
                                    />
                                </div>
                            );
                        }
                        return false;
                    })}
                </div>
            )}
            {Array.isArray(results) && results.length > 0 && (
                <MatchList
                    results={results}
                    event={event}
                    draw={null}
                    gameType={gameType}
                    eligibleResults={eligibleResults}
                    subscriptionType={subscriptionType}
                    showVerified={showVerified}
                    playerId={playerId}
                    limitResultDisplay={limitResultDisplay}
                    showDecimalForOwn={showDecimalForOwn}
                    isProProfile={isProProfile}
                    auth={auth}
                    redirectUrl={redirectUrl}
                    scoreStatusMap={scoreStatusMap}
                    onScoreUpdateRequest={onScoreUpdateRequest}
                    skipBatchCall={true}
                />
            )}
        </div>
    );
};

export default EventItem;
